import React, { Component } from "react";
import DATEPICKER_OR from "../../../../../common/custom-form/custom-date-picker.component";
import { InputField } from "../../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../../common/custom-form/select-filter.component";
import { TextArea } from "../../../../../common/custom-form/custom-textarea.component";


export class RateManagement extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue: "",
            filterSelected: "", 
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
        }
    }
    render() {
        return(
            <>
                <h1>Rate Details</h1>
                        <div className="manage-order-container">
                            <div className="manage-order-detail grid-2-1fr-column">
                                <SelectField label="CONTRACT NAME"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                <InputField label="Rate Name" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="Price" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <SelectField label="STATUS"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                <InputField label="Vendor" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="Currency" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="Service Type" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="Country / Location" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <DATEPICKER_OR label="Effective DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>    
                                <DATEPICKER_OR label="Expiration DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>    
                             </div>
                        </div>
                        <h1>Rate Values</h1>
                        <div className="manage-order-container">                          
                            <div className="manage-order-detail grid-2-1fr-column">                               
                                <InputField label="UNIT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <TextArea customClass="grid-item-span-3" label="Comments" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />  
                                <InputField label="RATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />  
                                <InputField label="Quality" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                                
                            </div>
                        </div>  
                        <h1>Attributes</h1>
                        <div className="nocontract-details-container">
                            <span>No contract attribute</span>
                        </div>                                              
            </>
        )
    }
}